import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AddClientRequest } from '../../_models/customers/client/AddClientRequest';
import { ResDataModal } from '../../modules/pages/customers/list-customers/ResDataModal';
import { ClientRequest } from '../../_models/customers/client/ClientRequest';
import { ClientSearch } from '../../_models/customers/client/ClientSearch';
import { EditAdClient } from '../../_models/customers/client/EditAdClient';
import { ClientListResponse, ClientResponse } from '../../_models/customers/client/ClientResponse';
import { ClientType } from "../../_models/customers/client/ClientType";
import { SearchClientResponse } from "../../_models/customers/client/SearchClientResponse";
import { AgencyGroupRequest } from '../../_models/customers/client/AgencyGroupRequest';
import { RequireAtLeastOne } from "../../shared/utils/types.utils";
import { EnvService } from '../configurations/env.service';
import { FilterBody, FilterRequest } from 'src/app/_models/commons/FilterRequest';


@Injectable({ providedIn: 'root' })
export class ClientService {
   expert: boolean;
   private env = inject(EnvService);

   constructor(private http: HttpClient) {
   }
   private apiURL = this.env?.readConfig()?.apiUrl;
   addClient(addClientRequest: AddClientRequest): Observable<any> {
      return this.http.post<any>(`${this.apiURL}/client/add`, addClientRequest, { withCredentials: true });
   }

   getCustomers(client: ClientRequest): Observable<SearchClientResponse> {
      return this.http.post<SearchClientResponse>(`${this.apiURL}/client/list`, client, { withCredentials: true });
   }

   getData(): Observable<ResDataModal> {
      return this.http.get<ResDataModal>(`${this.apiURL}/client/listClient`);
   }

   getAnnonceurs(): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/annonceur`);
   }

   getAnnonceursDataReduce(): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/annonceurDataReduce`);
   }

   getClientByNameOrSiren(name: string): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/annonceurDataReduce/${name}`);
   }

   searchClientList(value: string, customerType: 'FINAL' | 'INTERMEDIAIRE' | 'INTERMEDIAIRE_GROUP' = 'INTERMEDIAIRE'): Observable<ClientListResponse> {
      
      const body: FilterBody = {
         fieldFilters: [
            {
               filterKey: 'name',
               filterType: 'CONTAINS',
               filter: value?.trim() || ''
            },
            {
               filterKey: 'customerType',
               filterType: 'EQUAL', 
               filter: customerType
            }
         ]
      };

      return this.http.post<ClientListResponse>(`${this.apiURL}/client/list`, body);
   }


   getAgences(clientCrmId?: string, withLinkPlanner?: boolean, date?: string): Observable<ClientResponse[]> {
      let params = new HttpParams();
      if (clientCrmId) {
         params = params.set('clientCrmId', clientCrmId);
      }
      if (withLinkPlanner !== undefined) {
         params = params.set('withLinkPlanner', String(withLinkPlanner));
      }
      if (date) {
         params = params.set('date', date);
      }
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/agence`, { params });
   }

   getGroupAgences(): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/agencyGroup`);
   }

   getAgencyByAgencyGroup(agencyGroup: RequireAtLeastOne<AgencyGroupRequest, "customerIds" | "crmIds">): Observable<ClientResponse[]> {
      return this.http.post<ClientResponse[]>(`${this.apiURL}/client/agencyByAgencyGroup`, agencyGroup);
   }

   getClients(): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/clients`);
   }

   getClientType(): Observable<ClientType[]> {
      return this.http.get<ClientType[]>(`${this.apiURL}/client/type`);
   }

   getInterneClients(): Observable<ClientResponse[]> {
      return this.http.get<ClientResponse[]>(`${this.apiURL}/client/interne`);
   }

   getClientByEmail(email: string): Observable<ClientResponse> {
      return this.http.get<ClientResponse>(`${this.apiURL}/client/clientByEmail/${email}`);
   }

   getClientBySiren(clientSearch: ClientSearch): Observable<ClientResponse> {
      return this.http.post<ClientResponse>(`${this.apiURL}/client/clientBySiren`, clientSearch, { withCredentials: true });
   }

   getSirenByName(name: string): Observable<string> {
      return this.http.get<string>(`${this.apiURL}/client/clientByName/${name}`);
   }

   editCustomer(client: EditAdClient): Observable<boolean> {
      return this.http.post<boolean>(`${this.apiURL}/client/editCustomer`, client, { withCredentials: true });
   }

   certified(clientSearch: ClientSearch): Observable<any> {
      return this.http.post(`${this.apiURL}/client/certify`, clientSearch, { withCredentials: true });
   }

   getExpert(clientSearch: ClientSearch): Observable<boolean> {
      if (this.expert) {
         return of(this.expert);
      } else {
         const expertable = this.http.post<boolean>(`${this.apiURL}/client/expert`, clientSearch, { withCredentials: true });
         expertable.subscribe(
            (res) => {
               this.expert = res;
            })
         return expertable;
      }
   }

   getIndustry(): Observable<any> {
      return this.http.get(`${this.apiURL}/ext/salesforce/industry`);
   }

   getBySiret(siret: string): Observable<any> {
      return this.http.get(`${this.apiURL}/client/clientBySiret/${siret}`);
   }
}
